import type {Expand} from '../types';

import {certificateExpandCommon} from '../certificate';
import {channelExpandCommon} from '../channel';
import {conferenceExpandCommon} from '../conference';
import {courseExpandCommon} from '../course';
import {inviteExpandCommon} from '../invite';
import {membershipExpandCommon} from '../membership';
import {programExpandCommon} from '../program';
import {userQuestionnaireExpandCommon} from '../questionnaire';
import {taskExpandCommon} from '../task';
import {userExpandCommon} from '../user';
import {extendExpand, omitExpand} from '../utils/expand';

export const eventExpandCommon: Expand = {};

export const notificationEventExpand: Expand = {
  event: [
    [
      'actor_id',
      {coach_title: 'Coach not found', name: 'User not found'},
      userExpandCommon,
    ],
    [
      'context_ids',
      null,
      {
        ...programExpandCommon,
        ...userExpandCommon,
        ...courseExpandCommon,
        ...certificateExpandCommon,
        bound_form: ['user_id'],
        payment: ['original_payment_ids'],
        ...inviteExpandCommon,
        post: [['channel_id', null, channelExpandCommon]],
        ...omitExpand(conferenceExpandCommon, ['archives.file_id']),
        ...omitExpand(taskExpandCommon, [
          'attachment_ids',
          'coach_attachment_ids->coach_attachments',
        ]),
        ...extendExpand(omitExpand(membershipExpandCommon, ['program_id']), [
          ['coach_ids->coaches', {name: 'User not found'}, userExpandCommon],
        ]),
        ...userQuestionnaireExpandCommon,
      },
    ],
  ],
};
